/** Start and end indexes (inclusive) of one unbroken run of readings. */
export type Segment = readonly [number, number];

/** Splits sorted reading times wherever consecutive readings are more than `gapMs` apart. */
export const segmentsOf = (t: readonly number[], gapMs: number): Segment[] => {
  const segments: Segment[] = [];
  let start = 0;
  for (let i = 1; i < t.length; i += 1) {
    if (t[i] - t[i - 1] > gapMs) {
      segments.push([start, i - 1]);
      start = i;
    }
  }
  if (t.length > 0) segments.push([start, t.length - 1]);
  return segments;
};
